export default __webpack_public_path__ + "static/media/flag-dk.9452eea5.svg";